"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experiments = exports.Experiment = void 0;
// Add client side typeahead experiment info to the below enum for logging purpose
var Experiment;
(function (Experiment) {
  Experiment[Experiment["EGTA_BEX_ML_V0"] = 36094] = "EGTA_BEX_ML_V0";
  Experiment[Experiment["EGTA_uTA_Demo"] = 32216] = "EGTA_uTA_Demo";
  Experiment[Experiment["ESS_Two_Line_Display"] = 33686] = "ESS_Two_Line_Display";
  Experiment[Experiment["PWA_ESS_Feedback_Loop_Enable"] = 31052] = "PWA_ESS_Feedback_Loop_Enable";
  Experiment[Experiment["EGTA_Rollout_Feature_Gate_for_Hotel_Property_Name_Filter"] = 37339] = "EGTA_Rollout_Feature_Gate_for_Hotel_Property_Name_Filter";
  Experiment[Experiment["BEX_Driveable_destination_Web"] = 41955] = "BEX_Driveable_destination_Web";
})(Experiment = exports.Experiment || (exports.Experiment = {}));
var Experiments = /** @class */function () {
  function Experiments() {}
  Experiments.init = function (experiments) {
    var _this = this;
    if (experiments) {
      Object.keys(Experiment).forEach(function (name) {
        var value = experiments[name];
        var bucket;
        if ("number" === typeof value) {
          // Blossom-flex
          bucket = value;
        } else if (value && "number" === typeof value.bucket) {
          // Shopping-pwa
          bucket = value.bucket;
        }
        if (bucket !== undefined) {
          var id = Experiment[name];
          _this.experimentMap[id] = {
            id: id,
            name: name,
            bucket: bucket
          };
        }
      });
    }
  };
  Experiments.isBucketed = function (experiment, bucket) {
    if (bucket === void 0) {
      bucket = 1;
    }
    return experiment in this.experimentMap && bucket === this.experimentMap[experiment].bucket;
  };
  Experiments.getClientVariants = function () {
    var _this = this;
    var variants = [];
    Object.keys(this.experimentMap).forEach(function (key) {
      variants.push(key + "." + _this.experimentMap[key].bucket);
    });
    return variants.join("|");
  };
  Experiments.experimentMap = {};
  return Experiments;
}();
exports.Experiments = Experiments;